import axios from 'axios'
import { getHeaders, getBase} from '../utils/requests'

axios.defaults.withCredentials = true

const config = {
  withCredentials: true
}

// Handles login logic and auth check
export const getUserinfo = () => {
  const timestamp = new Date().getTime()
  const apiBaseUrl = getBase()
  return axios(`${apiBaseUrl}/editor/userinfo?t=${timestamp}`, {
    headers: getHeaders(),
    method: 'get'
  })
}

export const authenticateUser = (username, password) => {
  const data = {
    username,
    password
  }
  return axios.post(`${getBase()}/auth/login`, data, {
    headers: getHeaders(),
    withCredentials: true
  })
}

export const registerUser = async data => {
  return axios.post(`${getBase()}/auth/register`, data, {
    headers: getHeaders(),
    withCredentials: true
  })
}

export const authenticateFacebook = () => {
  const base = getBase()
  const url = `${base}/auth/facebook`
  window.location.replace(url, {
    withCredentials: true
  })
}

export const authenticateGoogle = () => {
  const base = getBase()
  const url = `${base}/auth/google`
  window.location.replace(url, {
    withCredentials: true
  })
}


export const checkAuth = () => {
  return axios.get(`${getBase()}/auth/check`, {
    withCredentials: true
  })
}

export const getSubscriptions = () => {
  return axios.get(`${getBase()}/auth/pricing`, {
    withCredentials: true
  })
}

export const fetchTeam = id => {
  return axios.get(`${getBase()}/auth/team/members?designId=${id}`, {
    withCredentials: true
  })
}

export const logout = () => {
  return axios.get(`${getBase()}/auth/logout`, {
    withCredentials: true
  })
}

export const getShareServices = () => {
  return axios.get(`${getBase()}/auth/share`, {
    withCredentials: true
  })
}

export const addAccount = (type, designId) => {
  return axios.get(`${getBase()}/auth/share/add?type=${type}&designId=${designId}`, {
    withCredentials: true
  })
}

export const createSharedPost = body => {
  return axios.post(`${getBase()}/auth/share`, body, {
    withCredentials: true
  })
}

export const shareWithTeam = body => {
  return axios.put(`${getBase()}/auth/team/share-design`, body, config)
}

export const deleteSharedAccount = (serviceId, accountId) => {
  return axios.get(`${getBase()}/auth/share/delete?serviceId=${serviceId}&accountId=${accountId}`, {
    withCredentials: true
  })
}

export const inviteToDesign = body => {
  return axios.post(`${getBase()}/auth/invite`, body, {
    withCredentials: true
  })
}